<dx-popup
    #arInvoiceEditorPopup
    [title]="popUpTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    Height="85%"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="ar-invoice-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!invoiceEditorData">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [colCount]="3" [formData]="invoiceInfo">
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Customer Name"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                cssClass="cc-hyper-link"
                                mode="hyperlinkOnly"
                                [displayText]="invoiceEditorData?.name"
                                (onLinkClick)="onCustomerNameClick()"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="isInternalUser">
                        <div class="history-icon" *dxTemplate>
                            <dx-toolbar>
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        <dx-button
                                            [icon]="historyIcon"
                                            hint="Transaction History"
                                            (onClick)="onTransactionLogClick()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Account ID"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceInfo?.customerCode }}</span>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Document Type"></dxo-label>
                        <div *dxTemplate>
                            {{ invoiceEditorData?.documentType }}
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Last Updated by"></dxo-label>
                        <div *dxTemplate>
                            {{ invoiceEditorData?.updatedDetails?.displayName }} on {{
                            invoiceEditorData?.updatedDetails?.updatedTime | date: dateFormat }}
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [disabled]="!allowFullEdit"
                                [(value)]="invoiceInfo.documentDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [min]="invoiceEditorData.minPostDate"
                                [(value)]="invoiceInfo.postDate"
                                [disabled]="!allowFullEdit"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Number"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                [disabled]="!allowFullEdit"
                                [(value)]="invoiceInfo.documentNumber"
                            ></dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [searchEnabled]="true"
                                [disabled]="!allowFullEdit"
                                [dataSource]="invoiceEditorData?.subLedgers"
                                [(value)]="invoiceInfo.subLedgerId"
                                (onValueChanged)="onSubLedgerChanged($event, cellInfo)"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Supporting Document"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                *ngIf="!!invoiceEditorData?.supportDocument?.fileName"
                                cssClass="cc-hyper-link"
                                mode="hyperlinkOnly"
                                [displayText]="invoiceEditorData?.supportDocument?.fileName"
                                (onLinkClick)="downloadSupportDocument()"
                            ></app-hyperlink-creator>
                        </div>
                        <span *ngIf="!invoiceEditorData?.supportDocument?.fileName">N/A</span>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area
                                [disabled]="!allowFullEdit && !allowPartialEdit"
                                [(value)]="invoiceInfo.description"
                            ></dx-text-area>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto" *ngIf="allowAddDeleteLineItems">
                <div *dxTemplate class="toolbar-container">
                    <dx-toolbar>
                        <dxi-item
                            location="after"
                            widget="dxButton"
                            [options]="{
                                type: 'default',
                                template: 'multiIconTemplate',
                                text: addLineItemButtonOptions,
                                onClick: onNewLineItemClick
                            }"
                        ></dxi-item>
                        <app-multi-icon-button-template></app-multi-icon-button-template>
                    </dx-toolbar>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        #arInvoiceEditorGrid
                        *ngIf="!!invoiceInfo"
                        height="95%"
                        keyExpr="itemId"
                        class="cc-vertical-center-cell-data-grid"
                        [dataSource]="invoiceInfo.items"
                        [allowColumnReordering]="true"
                        [allowColumnResizing]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        (onRowUpdated)="onRowUpdated($event)"
                        (onContentReady)="onEditorContentReady($event)"
                    >
                        <dxo-editing
                            mode="cell"
                            selectTextOnEditStart="true"
                            allowUpdating="true"
                            [useIcons]="true"
                        ></dxo-editing>
                        <dxo-pager [visible]="false"></dxo-pager>
                        <dxo-paging [enabled]="false"></dxo-paging>

                        <dxo-load-panel [enabled]="false"></dxo-load-panel>

                        <dxi-column
                            caption="Delete"
                            cellTemplate="deleteCellTemplate"
                            width="60"
                            *ngIf="allowAddDeleteLineItems"
                        ></dxi-column>
                        <dxi-column
                            dataType="number"
                            caption="Item #"
                            width="70"
                            cellTemplate="itemNumber"
                            allowEditing="false"
                        ></dxi-column>
                        <dxi-column
                            caption="Account"
                            dataField="selectedAccountName"
                            dataType="string"
                            width="220"
                            headerCellTemplate="mandatoryCellTemplate"
                            editCellTemplate="accountEditCellTemplate"
                            [showEditorAlways]="allowFullEdit"
                            [allowEditing]="allowFullEdit"
                        ></dxi-column>

                        <ng-container *ngIf="entityUsesSubCategory">
                            <dxi-column
                                dataField="subCategory"
                                dataType="string"
                                caption="Sub Category"
                                width="200"
                                allowSorting="false"
                                editCellTemplate="subCategoryTemplate"
                                [showEditorAlways]="allowFullEdit || allowPartialEdit"
                                [allowEditing]="allowFullEdit || allowPartialEdit"
                            ></dxi-column>
                        </ng-container>

                        <dxi-column
                            dataField="amount"
                            dataType="number"
                            caption="Amount"
                            width="110"
                            headerCellTemplate="mandatoryCellTemplate"
                            [showEditorAlways]="allowFullEdit"
                            [allowEditing]="allowFullEdit"
                            [editorOptions]="{ format: currencyFormat }"
                        ></dxi-column>

                        <ng-container *ngIf="dimensionSource.length > 0">
                            <ng-container *ngFor="let col of dimensionSource">
                                <dxi-column
                                    width="180"
                                    dataType="string"
                                    allowSorting="false"
                                    [dataField]="col.code"
                                    [caption]="col.text"
                                    headerCellTemplate="requiredColumnHeaderTemplate"
                                    [showEditorAlways]="allowFullEdit"
                                    [allowEditing]="allowFullEdit"
                                    [editorOptions]="{ placeholder: '' }"
                                >
                                    <dxo-lookup
                                        [dataSource]="col.options"
                                        displayExpr="text"
                                        valueExpr="code"
                                        allowClearing="true"
                                    ></dxo-lookup>
                                    <dxi-validation-rule *ngIf="col.required" type="required"></dxi-validation-rule>
                                </dxi-column>
                            </ng-container>
                        </ng-container>

                        <dxi-column
                            dataField="description"
                            dataType="string"
                            caption="Description"
                            [showEditorAlways]="allowFullEdit || allowPartialEdit"
                            [allowEditing]="allowFullEdit || allowPartialEdit"
                            [editorOptions]="{ showClearButton: true }"
                        ></dxi-column>

                        <div *dxTemplate="let header of 'mandatoryCellTemplate'">
                            {{ header.column.caption }}
                            <sup class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let header of 'requiredColumnHeaderTemplate'">
                            {{ header.column.caption }}
                            <sup *ngIf="header.column.validationRules" class="cc-text-required">*</sup>
                        </div>

                        <div *dxTemplate="let cellInfo of 'subCategoryTemplate'">
                            <dx-select-box
                                displayExpr="title"
                                valueExpr="code"
                                [searchEnabled]="true"
                                [disabled]="cellInfo.data.disableSubCategory"
                                [dataSource]="cellInfo.data.subCategorySource"
                                [(value)]="cellInfo.data.subCategoryCode"
                            ></dx-select-box>
                        </div>

                        <div *dxTemplate="let d of 'deleteCellTemplate'">
                            <dx-button
                                type="danger"
                                stylingMode="text"
                                [icon]="iconDelete"
                                (onClick)="onDeleteFromGrid(d.data)"
                            ></dx-button>
                        </div>

                        <div *dxTemplate="let item of 'itemNumber'">
                            <span>
                                {{ item.row.rowIndex + 1 }}
                            </span>
                        </div>

                        <div *dxTemplate="let cellInfo of 'accountEditCellTemplate'">
                            <app-account-selector
                                [accountTypeSource]="accountTypeSource"
                                [glAccountLabelSource]="glAccountLabelSource"
                                [glAccounts]="glAccountNumberSource"
                                [defaultOffsetGLAccountNumber]="defaultOffsetGLAccountNumber"
                                [selectedAccountType]="cellInfo.data.accountType"
                                [selectedAccountLabel]="cellInfo.data.accountLabelCode"
                                [selectedGLAccountNumber]="cellInfo.data.glAccountNumber"
                                [selectedOffsetAccount]="cellInfo.data.offsetGLAccountNumber"
                                [value]="cellInfo.value"
                                [cellInfo]="cellInfo"
                                (onSelection)="onAccountSelection($event, cellInfo)"
                            ></app-account-selector>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onHidden()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#arInvoiceEditorPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="communityId"
    (onTransactionLogClose)="displayTransactionLogPopUp = false"
></app-transaction-history>

<cc-message-box #arInvoiceMessageBox></cc-message-box>
